<template>
  <div class="app-wrapper" :class="classObj">
    <sidebar class="sidebar-container"></sidebar>
    <div class="main-container">
      <navbar @changePassword="changePassword"></navbar>
      <app-main></app-main>
    </div>
    <el-dialog
      title="修改密码"
      :visible="showEditDialog"
      @close="showEditDialog = false"
    >
      <div class="card-body">
        <div class="supplierItem">
          <span>请输入旧密码：</span>
          <el-input
            :type="pwdType"
            placeholder="请输入旧密码"
            v-model="oldPass" clearable
          ></el-input>
        </div>
        <div class="supplierItem">
          <span>请输入新密码：</span>
          <el-input
            :type="pwdType"
            placeholder="请输入新密码"
            v-model="newPass" clearable
          ></el-input>
        </div>
        <div class="supplierItem">
          <span>再次输入密码：</span>
          <el-input
            :type="pwdType"
            placeholder="请再次输入密码"
            v-model="newSecondPass" clearable
          ></el-input>
        </div>
        <div>
          <el-button
            size="small"
            type="success"
            @click="confirmEdit"
            style="margin-top: 20px; width: 100px"
          >
            保存
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from "./components";
import ResizeMixin from "./mixin/ResizeHandler";
import { setCookie, getCookie } from "@/utils/support";
import * as pharmacyTool from "@/api/pharmacyMS";
import * as stringTool from "@/utils/stringUtils";
export default {
  name: "layout",
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  data() {
    return {
      showEditDialog: false,
      oldPass: "",
      newPass: "",
      newSecondPass: "",
      pwdType: "password"
    };
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar;
    },
    device() {
      return this.$store.state.app.device;
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === "mobile"
      };
    }
  },
  methods: {
    changePassword() {
      console.log("------changePassword--------");
      (this.oldPass = ""), (this.newPass = ""), (this.newSecondPass = "");
      this.showEditDialog = true;
    },
    confirmEdit() {
      var localPass = getCookie("password");
      if (this.oldPass != localPass) {
        this.$message.error("您输入的原始密码不正确");
        return;
      }
      if (stringTool.isNULL(this.newPass)) {
        this.$message.error("新密码不能为空");
        return;
      }
      if (this.newPass != this.newSecondPass) {
        this.$message.error("新密码前后输入不一致");
        return;
      }
      var dataParam = {
        username: getCookie("username"),
        oldPassword: this.oldPass,
        newPassword: this.newPass
      };
      var that = this;
      pharmacyTool
        .updatePassword(dataParam)
        .then(data => {
          if (data.success) {
            that.$message({
              message: "密码更改成功",
              type: "success"
            });
            setCookie("password", that.newPass, 15);
            that.showEditDialog = false;
            that.setShowData();
          } else {
            that.$message.error(data.message);
          }
        })
        .catch(function(error) {});
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  .main-container {
    display: flex;
    flex-direction: column;
  }
  .supplierItem {
    margin-bottom: 15px;
    .el-input {
      width: 250px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue